/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Co2maxsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Maximum CO2 setpoint" |
*
* @param {Ahu_History_Key_Co2maxsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_co2maxsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Co2maxsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Co2maxsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum CO2 setpoint")
	return /** @type {LocalizedString} */ ("Consigne maximum de CO2")
});
export { ahu_history_key_co2maxsetpoint2 as "ahu_history_key_co2MaxSetpoint" }